import _regeneratorRuntime from "/Users/mgraczyk/dev/redux-url-store/examples/calculator/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/mgraczyk/dev/redux-url-store/examples/calculator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var _STATE_PARAM_KEY = '__rus';
var _INIT_ACTION_TYPE = 'REACT_URL_STORE_INIT';

var sleep = function sleep(ms) {
  return new Promise(function (r) {
    return setTimeout(r, ms);
  });
}; // Wraps a function and forwards results to a callback.
// Drops pending calls when a new call comes in,
// but always eventually returns the latest result.
//
//         \       \   \  \
// wrapped -\-------\---\--\------------
//           \       \   \  ~~~~~   <<< Wait a bit (predict cancel)
//            \       \   \      \
// await f ----???-----??x-?x-----???---
//                \                  \
//      cb -----------------------------


var withEagerLatestRace = function withEagerLatestRace(f, cb) {
  var limitMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var ctr = 0;
  var tLast = 0;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var myCtr,
          tWait,
          _len,
          args,
          _key,
          result,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              myCtr = ctr += 1;
              tWait = tLast + limitMs - performance.now();

              if (!(tWait > 0)) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return sleep(tWait);

            case 5:
              if (!(ctr !== myCtr)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              tLast = performance.now();

              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }

              _context.next = 11;
              return f.apply(void 0, args);

            case 11:
              result = _context.sent;

              if (ctr === myCtr) {
                cb(result, args);
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  );
}; // TODO: Fix for non-ascii.


function encodeState(state) {
  return window.btoa(JSON.stringify(state));
}

function decodeState(encodedState) {
  if (!encodedState) {
    return null;
  }

  try {
    return JSON.parse(window.atob(encodedState));
  } catch (error) {
    console.error(error);
    return null;
  }
}

function putStateInUrl(state) {
  var urlParams = new URLSearchParams(window.location.search);
  var encoded = encodeState(state);
  urlParams.set(_STATE_PARAM_KEY, encoded);
  window.history.replaceState(null, null, "".concat(window.location.pathname, "?").concat(urlParams));
}

function loadInitialState() {
  var urlParams = new URLSearchParams(window.location.search);
  console.log(urlParams);
  return decodeState(urlParams.get(_STATE_PARAM_KEY)) || {};
}

function createUrlStoreMiddleware() {
  var timeoutMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      var maybeUpdateStore = withEagerLatestRace(function () {}, function () {
        putStateInUrl(getState());
      }, timeoutMs);
      return function (action) {
        var result = next(action);
        maybeUpdateStore();
        return result;
      };
    };
  };
}

var urlStoreMiddleware = createUrlStoreMiddleware();
export { loadInitialState, urlStoreMiddleware };